const INQUIRY_API_URL = process.env.REACT_APP_INQUIRY_API_URL || '/api/send-inquiry';

export const sendInquiryEmail = async ({
  formName,
  name = '',
  email = '',
  phone = '',
  subject = '',
  service = '',
  currentEducation = '',
  interestedIn = '',
  message = '',
}) => {
  const payload = {
    siteName: 'SwiftMaze Tech',
    formName,
    name: name.trim(),
    email: email.trim(),
    phone: phone.trim(),
    subject: subject.trim(),
    service: service.trim(),
    currentEducation: currentEducation.trim(),
    interestedIn: interestedIn.trim(),
    message: message.trim(),
    sourceUrl: window.location.href,
    device: navigator.userAgent,
  };

  const response = await fetch(INQUIRY_API_URL, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    let message = 'Email submission failed.';
    try {
      const errorPayload = await response.json();
      message = errorPayload.message || message;
    } catch (error) {
      // Keep default message when response is not JSON.
    }
    throw new Error(message);
  }

  return response.json();
};
